<template>
  <div id="editDealConfirm">
    <div v-show="showButtons">
      <div class="editBtn" @click="toEditMode" v-if="!editMode && !hideEdit">
        <pt-icon type="icon-bianji1" class="editIcon"></pt-icon>
      </div>
      <div v-if="editMode">
        <div style="display: flex; justify-content: flex-end;margin: 5px 0;">
          <!--<a-button @click="cancelEdit" style="margin-right: 10px;">{{$t('baseVO.cacel')}}</a-button>-->
          <!--<a-button @click="saveDealConfirm" type="primary">{{$t('baseVO.save')}}</a-button>-->
        </div>
      </div>
    </div>
    <div v-if="!editMode">
      <div style="margin-bottom: 10px;">
        <a-row>
          <a-row :gutter="10">
          <pt-tag  v-if="defaultValue.frozen"style="cursor: pointer" :color="'default'"
                   :text="$t('dealConfirm.isFrozen')" type="triangle" size="small"></pt-tag>
          </a-row>
          <a-row :gutter="10">
            <a-col :span="10">
              <div class="itemTextDiv">
                <div class="title">{{$t('dealConfirm.payerId')}}</div>
                <div class="content_text">
                  <a-tooltip>
                    <template slot="title">
                      {{getCompanyName}}
                    </template>
                    {{getCompanyName}}
                  </a-tooltip>
                </div>
              </div>
            </a-col>
            <a-col :span="7">
              <div class="itemTextDiv">
                <div class="title">{{$t('dealConfirm.linkman')}}</div>
                <div class="content_text">{{getLinkmanName}}</div>
              </div>
            </a-col>
            <a-col :span="7">
              <div class="itemTextDiv">
                <div class="title">{{$t('dealConfirm.linkmanContact')}}</div>
                <div class="content_text">{{defaultValue.payerLinkmanContact}}</div>
              </div>
            </a-col>
          </a-row>
          <a-row :gutter="10">
            <!--<a-col :span="8" v-if="defaultValue.dealDO.dealOriginType == 1">-->
              <!--<a-col :span="8" class="title">{{$t('dealConfirm.commissionRate')}}:</a-col>-->
              <!--<a-col :span="16" class="content_text">{{defaultValue.commissionRate}}%</a-col>-->
            <!--</a-col>-->
            <a-col :span="10">
              <div class="itemTextDiv">
                <div class="title">{{$t('dealConfirm.totalComminssion')}}</div>
                <div class="content_text">
                  {{defaultValue.totalComminssion}}
                  <a-tooltip :title="$t('key17shijishoukuanjinge')" v-if="defaultValue.projectStages == 15">
                    <span  style="color:red;cursor: default">
                      ({{defaultValue.receiptCommission}})
                    </span>
                  </a-tooltip>
                  <pt-unit-select type="currency" v-model="defaultValue.totalComminssionUnit" :edit-mode="false"></pt-unit-select>
                </div>
              </div>
            </a-col>
            <a-col :span="7">
              <div class="itemTextDiv">
                <div class="title">{{$t('dealConfirm.payeeName')}}</div>
                <div class="content_text">{{defaultValue.payeeName}}</div>
              </div>
            </a-col>
            <a-col :span="7">
              <div class="itemTextDiv">
                <div class="title">{{$t('dealConfirm.expectPayeeTime')}}</div>
                <div class="content_text">
                  {{defaultValue.expectPayeeTime}}
                </div>
              </div>
            </a-col>
          </a-row>
	        <a-row :gutter="10">
		        <a-col :span="10">
			        <div class="itemTextDiv">
				        <div class="title">{{$t('dealConfirm.taxRate')}}</div>
				        <div class="content_text">{{defaultValue.taxRate}}%</div>
			        </div>
		        </a-col>
            <a-col :span="14">
              <div class="itemTextDiv">
                <div class="title">{{$t('keyyujishoukuanriqishuoming')}}</div>
                <div class="content_text">
                  <a-tooltip :title="defaultValue.changeDataRemarks" placement="topLeft">
                    {{defaultValue.changeDataRemarks}}
                  </a-tooltip>
                </div>
              </div>
            </a-col>
	        </a-row>
        </a-row>
      </div>
    </div>
    <pt-modal :title="$t('dealConfirm.addAgentAgreement')" :visible="agencyVisible"  :width="800"
              @cancel="hideAgency" @ok="submitAgency">
      <div slot="content">
        <addAgency></addAgency>
      </div>
    </pt-modal>
    <pt-modal :title="$t('commission.agency')" :visible="agencyDetailVisible"  @cancel="hideAgencyAgreement" :width="800" :footer="true">
      <div slot="content">
        <agencyDetail :agencyAgreementId="agency ? agency.id : null"></agencyDetail>
      </div>
    </pt-modal>
  </div>
</template>

<script>
  // import linkmanChangeRecordsApi from '@/api/database/linkmanChangeRecords'
  // import linkmanApi from '@/api/database/linkman'
  import agencyApi from '@/api/database/agencyAgreement'
  import addAgency from '@/views/database/agencyAgreement/module/addAgencyAgreement'
  import agencyDetail from '@/views/database/agencyAgreement/module/agencyAgreementDetail'
  // import dealConfirmApi from '@/api/mine/dealConfirm'
  import dealConfirmFileApi from '@/api/mine/dealConfirmFile'
  import DepApi from '@/api/sys/organization'

  export default {
    name: 'editDealConfirm',
    components:{
      VNodes: {
        functional: true,
        render: (h, ctx) => ctx.props.vnodes,
      },
      addAgency, agencyDetail
    },
    props: {
      hideEdit:{
        type:Boolean,
        default:false,
      },
      showButtons:{
        type:Boolean,
        default: true,
      },
      defaultValue:{
        type:Object,
        default: null
      },
    },
    computed:{
      getCompanyName(){
        // let company = this.allCompanyList.find(e=>{
        //   return e.key == this.defaultValue.payerId
        // })
        // return company ? company.companyName : ''
        if(this.defaultValue){
          return this.defaultValue.payerName == '~' ? this.defaultValue.payer : this.defaultValue.payerName
        }else{
          return '~'
        }
      },
      getLinkmanName(){
        return this.defaultValue.payerLinkman
        // let linkman = this.allLinkmanList.find(e=>{
        //   return e.id == this.defaultValue.payerLinkmanId
        // })
        // return linkman ? linkman.name : ''
      }
    },
    data() {
      return {
        agencyVisible: false,
        editMode: false,
        agencyDetailVisible: false,
        payeeName:undefined,
        agency:null,
        fileList:[],
        agencyList:[],
        dealConfirmForm: this.$form.createForm(this,{}),
        decorators:{
          id:['id',{}],
          payerId:['payerId',{rules:[{required:true,message:this.$t('deal.dealConfirm.errorInfo.payerId')}]}],
          linkman:['payerLinkmanId',{rules:[{required:true,message:this.$t('deal.dealConfirm.errorInfo.payerLinkmanId')}]}],
          commissionRate:['commissionRate',{}],
          totalComminssion:['totalComminssion',{}],
          expectPayeeTime:['expectPayeeTime',{}],
          receiptNum:['receiptNum',{}],
          receiptTime:['receiptTime',{}],
        },

        allCompanyList: [],
        allLinkmanList: []
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      getCompanyInfo() {
        console.log("------",this.defaultValue)
        if (this.defaultValue.payeeId != "0"){
          DepApi.selectCompanyInfo().then(res => {
            if (res.code == 1) {
              this.payeeName =  res.data.find(o=>o.id == this.defaultValue.payeeId ).name
            }
          })
        }else {
          this.payeeName ="~"
        }

      },
      cancelEdit(){
        this.editMode = false
      },
      // calculatePartakes(value){
      //   this.$nextTick(()=>{
      //     this.$emit('commissionFresh',this.dealConfirmForm.getFieldsValue())
      //   })
      // },
      // calculateTotalCommission(value){
      //   let budgetRent = this.defaultValue.dealDO.budgetRent
      //   let demandArea = this.defaultValue.dealDO.demandArea
      //   let projectPossible = this.defaultValue.dealDO.projectPossible
      //
      //   let commissionRate = value
      //   if(!isNaN(budgetRent) && !isNaN(demandArea) && !isNaN(projectPossible) && !isNaN(commissionRate)){
      //     let result = budgetRent * demandArea * projectPossible / 100 * commissionRate / 100
      //     this.dealConfirmForm.setFieldsValue({totalComminssion: result})
      //   }
      //
      //   this.$emit('commissionFresh',this.dealConfirmForm.getFieldsValue())
      // },
      changeCompanyName(value){
        this.companyName = this.allLinkmanList.find(e=>{
          return e.id == value
        }).companyName
      },
      changeCompanyId(value){
        this.initAgencyAgreement(value)
        this.initAllLinkmanList(value)
      },
      checkAgency(agency){
        this.agency = agency
      },
      clearAgencyAgreement(){
        this.agency = null
      },
      deleteDealConfirmFile(file){
        let this_ = this
        this.$ptConfirm({
          title: this_.$t('confirmInfo.deleteFile.title'),
          content: this_.$t('confirmInfo.deleteFile.content'),
          onOk() {
            return new Promise((resolve, reject) => {
              dealConfirmFileApi.deleteByDO(file).then(res=>{
                if(res.code == 1){
                  this_.$message.success(res.message)
                  this_.$emit('refresh')
                  resolve()
                }else{
                  reject()
                  this_.$message.error(res.message)
                }
              })
            }).catch(() => console.log('Oops errors!'));
          },
          onCancel() {},
        })
      },
      downloadFile(file){
        this.$util.dowLoadFile(file.fileId,file.fileName,this);
      },
      extractForm(){
        let validatePass = true
        this.dealConfirmForm.validateFieldsAndScroll((err,values) => {
          if (!err) {

          }else{
            validatePass = false
          }
        })
        if(!validatePass){
          return null
        }
        let dealConfirmVO = this.dealConfirmForm.getFieldsValue()
        dealConfirmVO.dealConfirmFileVOS = this.fileList
        dealConfirmVO.agencyId = this.agency != null ? this.agency.id : null
        return dealConfirmVO
      },
      hideAgency(){
        this.agencyVisible = false
      },
      hideAgencyAgreement(){
        this.agencyDetailVisible = false
      },
      init(){
        if(!this.defaultValue || this.defaultValue.payerId == '~' || this.defaultValue.payerId == null){
          return
        }
        this.getCompanyInfo()
        // this.initCompanyByKey().then(()=>{
          // this.initAllLinkmanList(this.defaultValue.payerId)
        // })
      },
      initCompanyByKey(){
        // if(!this.defaultValue || this.defaultValue.payerId == '~' || this.defaultValue.payerId == null){
        //   return
        // }
        // let p = new Promise((resolve,reject) => {
        //   linkmanChangeRecordsApi.queryByKey(this.defaultValue.payerId).then(res=>{
        //     if(res.code == 1){
        //       this.allCompanyList = res.data
        //       resolve()
        //     }else{
        //       reject()
        //     }
        //   })
        // })
        // return p
      },
      // initAllCompanyList(companyName){
      //   let p = new Promise((resolve, reject)=>{
      //     linkmanChangeRecordsApi.queryByName(companyName).then(res=>{
      //       if(res.code == 1){
      //         this.allCompanyList = res.data != null ? res.data : []
      //         resolve()
      //       }else{
      //         reject()
      //       }
      //     })
      //   })
      //   return p
      // },
      initAgencyAgreement(key){
        if(key == null || key == '~'){
          return
        }
        agencyApi.selectByCompanyId(key).then(res=>{
          if(res.code == 1){
            this.agencyList = res.data
          }else{

          }
        })
      },
      // initAllLinkmanList(value){
      //   let company = this.allCompanyList.find(e=>{return e.key == value})
      //   let p = new Promise((resolve,reject)=>{
      //     linkmanApi.listByTypeAndCompanyId(company.type,company.id).then(res=>{
      //       if(res.code == 1){
      //         this.allLinkmanList = res.data
      //         resolve()
      //       }else{
      //         reject()
      //       }
      //     })
      //   })
      //   return p
      // },
      initForm(){
        this.$nextTick(()=>{
          this.defaultValue.payerId == '~' && (this.defaultValue.payerId = null)
          this.defaultValue.payerLinkmanId == '0' && (this.defaultValue.payerLinkmanId = null)
          this.defaultValue.receiptNum == '~' && (this.defaultValue.receiptNum = null)
          this.defaultValue.expectPayeeTime = this.defaultValue.expectPayeeTime != '~' ? this.$moment(this.defaultValue.expectPayeeTime) : this.$moment()
          this.defaultValue.receiptTime = this.defaultValue.receiptTime != '~' ? this.$moment(this.defaultValue.receiptTime) : this.$moment()
          this.defaultValue.payerLinkmanContact == '~' && (this.defaultValue.payerLinkmanContact = undefined)
          this.defaultValue.payerLinkman == '~' && (this.defaultValue.payerLinkman = undefined)
          this.defaultValue.remarks == '~' && (this.defaultValue.remarks = undefined)
          this.dealConfirmForm.setFieldsValue(this.defaultValue)
          this.agency = this.defaultValue.agencyAgreementDO == '~' ? null : this.defaultValue.agencyAgreementDO
        })
      },
      onSuccess(file,fileId,number){
        this.fileList.push(Object.assign(file,{fileId:fileId}))
      },
      openAddAgencyModal(){
        this.agencyVisible = true
      },
      removeFile(file){
        this.fileList.splice(this.fileList.indexOf(file))
      },
      // saveDealConfirm(){
      //   let dealConfirmVO = this.dealConfirmForm.getFieldsValue()
      //   dealConfirmVO.dealConfirmFileVOS = this.fileList
      //   dealConfirmApi.updateDealConfirmDetails(dealConfirmVO).then(res=>{
      //     if(res.code == 1){
      //       this.cancelEdit()
      //       this.$emit('refresh')
      //     }else{
      //
      //     }
      //   })
      // },
      saveDealConfirmFile(file,fileId,number){
        let dealConfirmFileDO = {fileId: fileId, dealConfirmId: this.defaultValue.id}
        dealConfirmFileApi.insert(dealConfirmFileDO).then(res=>{
          if(res.code == 1){
            this.$message.success(res.message)
            this.$emit('refresh')
          }else{
            this.$message.error(res.message)
          }
        })
      },
      showAgencyAgreement(){
        this.agencyDetailVisible = true
      },
      submitAgency(){

      },
      toEditMode(){
        this.editMode = true
        this.initCompanyByKey()
        this.initAgencyAgreement(this.defaultValue.payerId)
        this.initForm()
      },
      toViewMode(){
        this.editMode = false
      },
    },
    watch:{
    }
  }
</script>

<style scoped lang="less">
  #editDealConfirm{
    .editBtn{
      text-align: right;
      .editIcon{
        font-size: 18px;
        cursor:pointer;
      }
    }
    .edit_mode_info{
      .ant-row{
        padding: 10px;
        background: rgba(248,249,251,0.62);
        border-radius: 0 0 4px 4px;
        margin-bottom: 0;
      }
    }
    .ant-row{
      padding: 10px;
      border-radius: 0 0 4px 4px;
      margin-bottom: 0;
    }
    .edit_mode_info{
      background: rgba(248,249,251,0.62);
      border-radius: 0 0 4px 4px;
    }
    .agency_info{
      font-size: 12px;
      color: #333333;
      background: #F4F5F8;
      border-radius: 2px;
      display: flex;
      align-items: center;
    }
    .upload_files{
      padding: 0 10px;
      .deal_files{
        background: #F4F5F8;
        display: flex;
        border-radius: 0 0 4px 4px;
      }
    }
    .itemTextDiv{
      display: flex;
      flex-direction: column;
      .title{
        font-size: 12px;
        color: #999999;
      }
      .content_text{
        font-size: 12px;
        color: #333333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

  }
</style>
<style lang="less">
  .addAgencyBtn{
    min-width: 600px;
    background: #3B2E26;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    height: 30px;
    margin-top: 20px;
    .addIcon{
      color: #ffffff;
      font-size: 12px;
    }
  }
  .owner_row{
    padding: 20px 25px 0 25px;
    font-size: 12px;
    color: #333333;
    font-weight: bold;
    background: #ffffff;
  }

</style>